<template>
  <div data-module="work-category-content">
    <work-articles-mobile v-if="isMobile" :articles="articlesData" />
    <work-articles-tablet v-else :articles="articlesData" />
  </div>
</template>

<script>
/*
*/
// Components
import WorkArticlesMobile from '@/components/work/WorkArticlesMobile';
import WorkArticlesTablet from '@/components/work/WorkArticlesTablet';

// Utils
import { groupAndShuffleArticleRecords } from '@/utils/data-utils';

// Data
import WorkCategoryIdx from '@/content/work-category-index';

export default {
  name: 'work-category-content',

  props: ['data'],

  components: {
    WorkArticlesMobile,
    WorkArticlesTablet,
  },

  computed: {

    articlesData() {
      const { category: catKey } = this.data;
      const recs = WorkCategoryIdx[catKey] || [];
      return groupAndShuffleArticleRecords(recs);
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },

  },

};
</script>

<style lang="scss" scoped>
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';

[data-module="work-category-content"] {
  width: 100%;
  background-color: lightsalmon;

  // media query props
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-bottom: rem($layout--default-module-spacing-desktop);
  }

}
</style>



// WEBPACK FOOTER //
// src/modules/work/CategoryContent.vue